// extracted by mini-css-extract-plugin
export default {"wrapper":"L4AmfG0mwCO23BhP418E","separator":"sT0v0zfbRIk7f2yGy4xM","textLong":"ag_kVZbGWRO18jZjFqMG","textShort":"hSESiUuzWQpQ0RKML4Wl"};